<template>
  <div>
    <div>
      <div class="new-invoice-info-table">
        <h4>{{`Showing ${to} from ${total}`}}</h4>
      </div>
    </div>
    <div class="all-table">
      <HeaderTable
        :button="true"
        :buttonAction="cButtonAction"
        @sendMetaPay="$emit('sendMetaPay')"
      />
      <div class="body-table">
        <template v-if="cActual.length > 0">
          <template v-if="loader">
            <Loader />
          </template>
          <table>
            <thead>
              <tr>
                  <th></th>
                  <th @click="ordernate('customer_name')">Customer
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>
                  <th @click="ordernate('email')">Email
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>

                  <th @click="ordernate('order_date')">Order Date
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>
                  <th @click="ordernate('invoice')">Invoice
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>
                  <th @click="ordernate('date')">Date
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>
                  <th @click="ordernate('amount')">Amount
                    <img
                      :src="require('@/assets/icons/sort.svg')"
                      alt="Order by customer name"
                    >
                  </th>
                  <th @click="ordernate('status')">PDF Preview</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(invoice, index) in cActual">
                <LineTable
                  :key="index"
                  :data="invoice"
                  @addInvoice="addInvoice($event)"
                />
              </template>
            </tbody>
          </table>
        </template>
        <template v-else>
          <Info />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader/LoaderTable.vue';
import Info from '@/components/Infos/Info.vue';
import HeaderTable from './HeaderTable.vue';
import LineTable from './LineTable.vue';

export default {
  name: 'invoice-incoming',
  data() {
    return {
      order: 'desc',
      all: false,
      loader: false,
      selecteds: [],
      currentPage: 0,
    };
  },
  props: {
    to: Number,
    total: Number,
    actual: [Array, String],
    loaderTable: Boolean,
    indexActual: Number,
  },
  components: {
    Loader,
    HeaderTable,
    LineTable,
    Info,
  },
  methods: {
    ordernate(collumn) {
      const newOrder = this.order;
      if (newOrder === 'desc') {
        this.order = 'asc';
        this.$emit('collumnSelected', { collumn, orderBy: 'desc' });
      } else {
        this.order = 'desc';
        this.$emit('collumnSelected', { collumn, orderBy: 'asc' });
      }
    },
    addInvoice(value) {
      if (value.bool) {
        this.selecteds.push(JSON.parse(value.value.json));
      } else {
        this.selecteds.splice(this.selecteds.indexOf(JSON.parse(value.value.json)), 1);
      }
      this.$store.commit('UPDATE_LIST', this.selecteds);
    },
  },
  watch: {
    '$store.getters.value': function selected() {
      this.selecteds = [];
    },
  },
  computed: {
    cActual() {
      if (this.actual) {
        return this.actual;
      }
      return '';
    },
    cButtonAction() {
      return this.selecteds.length > 0;
    },
  },
};
</script>
<style lang="scss" scoped>


table {
  width: 92.4vw;
  position: relative;
}
tbody {
  margin: 0 auto;
}
thead {
  tr {
    background-color: $backgroundLineTable;
    th {
      font-weight: 600;
      font-size: 14px;
      @media(min-width: 1440px) {
    width: 100%!important;
  }
    }
  }
}
tr {
  width: 100%;
  display: flex;
  &:nth-child(even) {
    background-color: $backgroundLineTable;
  }
}
th {
  display: flex;
  cursor: pointer;
  /* justify-content: center; */
  align-items: center;
  text-align: left;
  flex-direction: row;
  width: 200px;
  min-height: 65px;
  font-weight: 500;
  font-size: 13.8355px;
  margin: 0 2px;
  color: $dataTable;

  img {
    width: 14px;
    height: 14px;
  }

  &:first-child {
    width: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    input {
      margin-right: 5px;
    }
  }
  &:nth-child(2) {
    width: 150px;
  }
  &:nth-child(3) {
    width: 250px;
  }
  &:nth-child(4) {
    width: 120px;
  }
  &:nth-child(5) {
    width: 150px;
  }
  &:nth-child(6) {
    width: 180px;
  }
  &:nth-child(7) {
    width: 100px;
  }
  &:nth-child(8) {
    width: 100px;
  }
}
.all-table {
  position: relative;
  width: 92.4vw;
  margin: 0 auto;
  background-color: $white;
  border-radius: 5px;
  .title-table {
    padding-left: 29px;
    height: 60px;
    border-bottom: 2px solid $backgroundData;
    display: flex;
    align-items: center;
    color: $header;
    h1 {
      font-weight: 600;
      font-size: 24px;
    }
  }
  .body-table {
    /* width: 92.4vw;
    position: relative; */
    min-height: 150px;
    overflow-x: auto;
    .headers-table {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 29px;
      height: 65px;
    }
    .datas-table {
      @media (min-width: 1440px) {
        padding: 0 29px;
      }
      .line-table {
        display: flex;
        min-width: 1262px;
        justify-content: space-between;
        height: 65px;
        &:nth-child(odd) {
          background-color: $backgroundLineTable;
        }
        h2 {
          img {
            width: 25px;
            height: 25px;
            margin-right: 6px;
          }
          font-weight: 500;
          font-size: 13.8355px;
          color: $dataTable;
          display: flex;
          align-items: center;
          margin-right: 45px;
          white-space: nowrap;
          text-align: left;
          @media (min-width: 1440px) {
            margin-right: 0px !important;
          }
          img {
            cursor: pointer;
          }
          &:nth-child(1) {
            white-space: normal;
            padding-left: 29px;
            margin-right: 75px;
            min-width: 127px;
            max-width: 127px;
            @media (min-width: 1440px) {
              margin-right: 0px;
            }
          }
          &:nth-child(2) {
            min-width: 65px;
          }
          &:nth-child(3) {
            min-width: 79px;
          }
          &:nth-child(4) {
            min-width: 44px;
          }
          &:nth-child(5) {
            min-width: 110px;
          }
          &:nth-child(6) {
            min-width: 90px;
          }
          &:nth-child(7) {
            min-width: 140px;
          }
          @media (min-width: 1440px) {
            &:nth-child(1) {
              white-space: normal;
              padding-left: 29px;
              min-width: 10%;
              max-width: 10%;
            }
            &:nth-child(2) {
              min-width: 10%;
            }
            &:nth-child(3) {
              min-width: 10%;
            }
            &:nth-child(4) {
              min-width: 10%;
            }
            &:nth-child(5) {
              min-width: 10%;
            }
            &:nth-child(6) {
              min-width: 10%;
            }
            &:nth-child(7) {
              min-width: 10%;
            }
          }
        }
      }
    }
  }
}
.new-invoice-info-table {
  width: 92.4vw;
  margin: 0 auto;
  @media (max-width: 960px) {
    padding-left: 0 !important;
  }
  h4 {
    font-weight: 500;
    font-size: 14px;
    text-align: right;
    margin-bottom: 5px;
    color: #162056;
    @media (max-width: 600px) {
      width: 100%;
      padding-right: 10px;
      margin-right: -10px;
    }
  }
}
</style>
